<!--
 * @Author: yangchaunqi
 * @Date: 2020-12-29 21:32:24
 * @LastEditTime: 2021-01-07 08:42:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \beone\src\components\index.vue
-->
<template>
    <div>
        <div class="topHeader">
            <img src="@/assets/logos.png" style="width: 33.50vw;margin-left: 6vw; " alt=""/>
            <!--      <img src="@/assets/logo.png" style="width: 3.49vw;margin-left: 20vw " alt=""/>-->
            <!--      <img src="@/assets/ygxw.png" style="width: 23.635vw;margin-left: 1.51vw " alt=""/>-->
            <!--      <img src="@/assets/headerText.png" style="width: 16.615vw;margin-left:19.896vw " alt=""/>-->
        </div>
        <div class="tabs">
            <div @click="go('/home')" class="tabs-item">
                本站首页
            </div>
            <div style="height: 20px;width: 1px;background-color: #6f060a;box-shadow: 0px 1px 0px 0px #c7333a;">
            </div>
            <div @mouseenter="bsznEnter" @mouseleave="bsznLeave" class="tabs-item">
                服务指南
                <div class="bsznbox" v-if="bsznShow">
                    <div class="bsznbox-item" @click.stop="go('/work/org')">部门联系电话</div>
                    <div class="bsznbox-item" @click.stop="go('/work/guide')">办事流程</div>
                    <!--          <div class="bsznbox-item" @click.stop="go('/work/downList')">办事表格下载</div>-->
                    <!--          <div class="bsznbox-item" @click.stop="go('/work/telephone')">服务电话</div>-->
                </div>
            </div>
            <div style="height: 20px;width: 1px;background-color: #6f060a;box-shadow: 0px 1px 0px 0px #c7333a;">
            </div>
            <div class="tabs-item" @click="open">信息公开</div>
            <div style="height: 20px;width: 1px;background-color: #6f060a;box-shadow: 0px 1px 0px 0px #c7333a;">
            </div>
            <div class="tabs-item" @click="go('/appeal')">师生诉求</div>
            <div style="height: 20px;width: 1px;background-color: #6f060a;box-shadow: 0px 1px 0px 0px #c7333a;">
            </div>
            <div @mouseenter="leaderEnter" @mouseleave="leaderLeave" @click="go('/leaderDo')" class="tabs-item">
                领导信箱
                <!--        <div class="bsznbox" v-if="leaderShow">-->
                <!--          <div class="bsznbox-item" @click.stop="goEmail('/email/info',5)">书记信箱</div>-->
                <!--          <div class="bsznbox-item" @click.stop="goEmail('/email/info',2)">校长信箱</div>-->
                <!--        </div>-->
            </div>
            <div style="height: 20px;width: 1px;background-color: #6f060a;box-shadow: 0px 1px 0px 0px #c7333a;">
            </div>

            <div class="tabs-item" v-if="isLogin" @click="go('/myList')">我的服务</div>
            <div class="tabs-item" v-else @click="loginShow">点击登录</div>
        </div>
        <router-view style="min-height: 520px;margin: 0 auto;padding-bottom: 30px"></router-view>
        <!--    <div style=" background-color: #f0f0f0;margin-top: 10px;display:flex;align-items: center;justify-content: center">-->

        <!--    </div>-->
        <div class="footer">
            <div
                    style="display: flex;align-items: center;width: 1200px;justify-content: space-around;height: 50px;margin-top: 25px">
        <span class="footerText"><img src="@/assets/dian.png" style="margin-right: 8px"
                                      alt="">累计收件：{{ viewsDetails.appealCount }}</span>
                <span class="footerText"><img src="@/assets/dian.png" style="margin-right: 8px"
                                              alt="">已处理收件：{{ viewsDetails.processed }}</span>
                <span class="footerText"><img src="@/assets/dian.png" style="margin-right: 8px"
                                              alt="">未处理收件：{{ viewsDetails.untreated }}</span>
                <span class="footerText"><img src="@/assets/dian.png" style="margin-right: 8px"
                                              alt="">转交中：{{ viewsDetails.zjCount }}</span>
                <span class="footerText"><img src="@/assets/dian.png" style="margin-right: 8px" alt="">pv总量：<span
                        id="pv">{{ viewsDetails.pvCount }}</span></span>
                <span class="footerText"><img src="@/assets/dian.png" style="margin-right: 8px" alt="">访客数总量：<span
                        id="visitor">{{
                    viewsDetails.accessCount
                    }}</span></span>
                <span class="footerText"><img src="@/assets/dian.png" style="margin-right: 8px" alt="">今日访客数：<span
                        id="dayVisitor">{{ viewsDetails.nowCount }}</span></span>
            </div>
            <div style="margin-top: 50px;line-height: 32px;">技术支持
                <a class="footerA" style="color: #fff" href="http://demutec.cn/"
                   target="_blank">山东德沐信息科技有限公司</a>
            </div>
            <div>
                <!--        Email：<a class="footerA" style="color: #fff" href="mailto:sdxy@sdxianyun.com">sdxy@sdxianyun.com</a>-->
                联系电话：0533-6588858
                地址：山东省淄博市周村区北郊镇创业中心园区
            </div>
        </div>
        <a-modal title="登录" :visible="visible" :footer="false" @cancel="visible = false">
            <a-form :form="form">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号码" required>
                    <a-input placeholder="请输入手机号码" v-decorator="['userName',validatorRules.userName ]"/>
                </a-form-item>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="验证码">
                    <a-input-search @search="showImgCode" placeholder="请输入验证码"
                                    v-decorator="['smsCode',validatorRules.smsCode ]">
                        <a-button :disabled="yzText !== '获取验证码'" slot="enterButton">
                            {{ yzText }}
                        </a-button>
                    </a-input-search>
                </a-form-item>
            </a-form>
            <a-row>
                <a-col align="center">
                    <a-button @click="login" type="primary">登录</a-button>
                </a-col>
            </a-row>
            <a-modal title="图形验证码" :visible="imageCodeModal" @ok="onSearch" @cancel="imageCodeModal = false">
                <a-form>
                    <a-form-item style="display: flex;align-items: center;justify-content: space-between"
                                 :labelCol="labelCol" :wrapperCol="wrapperCol" label="图形验证码">
                        <a-input style="width: 60%" v-model="imageCode" placeholder="请输入图形验证码"></a-input>
                        <img style="margin-left: 10px" :src="imgCode" @click="getImgCode" alt="">
                    </a-form-item>
                </a-form>
            </a-modal>
        </a-modal>
    </div>
</template>
<script>
import {getAction, login} from "@/api/manage";

export default {
    name: "index",
    components: {},
    data() {
        return {
            imageCodeModal: false,
            bsznShow: false,
            leaderShow: false,
            viewsDetails: {},
            isLogin: false,
            visible: false,
            form: this.$form.createForm(this),
            yzText: '获取验证码',
            time: 60,
            timer: null,
            labelCol: {
                xs: {span: 24},
                sm: {span: 5},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 16},
            },
            logo: '',
            staticDomainURL: window._CONFIG['url'] + '/common/file/downLoadByJava?path=',
            validatorRules: {
                userName: {
                    rules: [
                        {validator: this.validatePhone,}
                    ],
                },
                smsCode: {
                    rules: [
                        {required: true, message: '请输入验证码！'}
                    ],
                },
            },
            imageCode: '',
            imgCode: '',
        };
    },
    activated() {
        this.getViewsDetails();
        this.getToken()
        this.getLogo()
    },
    methods: {
        showImgCode() {
            if (!this.form.getFieldValue('userName')) {
                this.$message.error('请先输入手机号码！')
                return
            }
            this.imageCode = ''
            this.imgCode = ''
            this.getImgCode()
            this.imageCodeModal = true
        },
        getImgCode() {
            getAction('/sys/getRandomImage?mobile=' + this.form.getFieldValue('userName')).then((data) => {
                this.imgCode = data.data
            })
        },
        open() {
            getAction('/macro/getDetails', {id: 3}).then((data) => {
                if (data.code === 0) {
                    if (data.data.value) {
                        if (data.data.value.indexOf('http') !== -1) {
                            window.open(data.data.value)
                        } else {
                            window.open('http://' + data.data.value)
                        }
                    } else {
                        this.$message.error('尚未配置信息公开链接地址！')
                    }
                } else {
                    this.$message.error(data.message)
                }
            })
        },
        getLogo() {
            getAction('/macro/getDetails', {id: 4}).then((data) => {
                this.logo = data.data.value
            })
        },
        login() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    login(values.userName, values.smsCode).then((data) => {
                        if (data.access_token) {
                            sessionStorage.setItem('token', data.access_token)
                            this.isLogin = true
                            this.$message.success('登录成功！')
                            this.visible = false
                        } else {
                            this.$message.error('登录失败！')
                        }
                    })
                }
            })
        },
        validatePhone(rule, value, callback) {
            if (!value) {
                callback()
            } else {
                //update-begin--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
                if (new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(value)) {
                    //update-end--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
                    callback()
                } else {
                    callback('请输入正确格式的手机号码!')
                }
            }
        },
        codeTime() {
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.time = TIME_COUNT;
                this.yzText = this.time + "秒后重新发送";
                //这里可以插入$axios调用后台接口
                this.timer = setInterval(() => {
                    if (this.time > 0 && this.time <= TIME_COUNT) {
                        this.time--;
                        this.yzText = this.time + "秒后重新发送";
                    } else {
                        this.yzText = "获取验证码";
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000);
            }
        },
        onSearch() {
            if (!this.imageCode) {
                this.$message.error('请输入验证码')
                return false
            }
            if (this.yzText !== '获取验证码') {
                return
            }
            this.form.validateFields(['userName'], (err, values) => {
                if (!err) {
                    getAction("/sys/sendSms", {mobile: values.userName, code: this.imageCode}).then((data) => {
                        if (data.code === 0) {
                            this.$message.success("发送成功!");
                            this.imageCodeModal = false
                            this.codeTime();
                        } else {
                            this.$message.error(data.message);
                        }
                    })
                }
            })
        },
        loginShow() {
            this.visible = true
            this.form.resetFields()
        },
        getToken() {
            if (sessionStorage.getItem('token')) this.isLogin = true
            else this.isLogin = false
        },
        getViewsDetails() {
            getAction("/user/appeal/getViewsDetails").then((data) => {
                this.viewsDetails = data.data;
            });
        },
        go(url) {
            if (this.$route.fullPath !== url) this.$router.push(url);
        },
        bsznEnter() {
            this.bsznShow = true;
        },
        bsznLeave() {
            this.bsznShow = false;
        },
        leaderEnter() {
            this.leaderShow = true;
        },
        leaderLeave() {
            this.leaderShow = false;
        },
        goEmail(url, type) {
            this.$router.push({
                path: url,
                query: {
                    type: type
                }
            })
        },
    },
};
</script>
<style lang="scss" scoped>
.topHeader {
  width: 100%;
  height: 132px;
  overflow: hidden;
  display: flex;
  align-items: center;
  //background: url(~@/assets/top.png) no-repeat center;
  background: url(~@/assets/bac.png) no-repeat center;
}

.tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 46px;
  //padding: 10px 0;
  //line-height: 54px;
  text-align: center;
  background-color: #a11319;
}

.tabs-item {
  display: flex;
  align-items: center;
  height: 46px;
  width: 160px;
  justify-content: center;
  color: white;
  position: relative;
  z-index: 999;
  //border-right: 1px solid #fff;
  box-sizing: border-box;
  cursor: pointer;

  img {
    margin-right: 8px;
  }
}

.tabs-item:hover {
  opacity: 0.8;
}

.bsznbox {
  width: 160px;
  position: absolute;
  top: 46px;
  left: 0;

  .bsznbox-item {
    display: flex;
    align-items: center;
    width: 160px;
    height: 54px;
    justify-content: center;
    color: white;
    background-color: rgba(161, 19, 25, 0.85);
    border-top: 1px solid #fff;
  }

  .bsznbox-item:hover {
    background-color: rgba(161, 19, 25, 0.9);
  }
}


.footer {
  height: 257px;
  background: url(~@/assets/di.png) 100% center;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column
}

.footerA {
  color: #fff;
  transition: 0.3s;
}

.footerText {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 32px;
  letter-spacing: 0px;
  color: #ffffff;
}

.footerA:hover {
  opacity: 0.8;
}
</style>
